import { z } from 'zod';

export const FieldGradeValidatorSchema = z.object({
  fieldId: z.string(),
  gradeId: z.string(),
  kidId: z.string().optional(),
});

export type FieldGradeValidator = z.infer<typeof FieldGradeValidatorSchema>;
